var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-spinner","appear":""}},[(_vm.show)?_c('div',{class:{ 'container-center': !_vm.infinite, 'container-top': _vm.infinite }},[_c('div',{attrs:{"id":"circle"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }